import React, { useState, useRef } from 'react';
import { IconButton } from '@mui/material';
import MicIcon from '@mui/icons-material/Mic';
import { cancelarVoz } from '../../util/voice';

interface AudioParaTextoProps {
  onTranscricao?: (texto: string) => void;
  disabled: boolean;
}

const AudioParaTexto: React.FC<AudioParaTextoProps> = ({ onTranscricao, disabled }) => {
  const [ouvindo, setOuvindo] = useState(false);
  const recognitionRef = useRef<SpeechRecognition | null>(null);

  const iniciarReconhecimento = () => {
    const SpeechRecognition =
      (window as any).SpeechRecognition ||
      (window as any).webkitSpeechRecognition;

    if (!SpeechRecognition) {
      alert('Este navegador não suporta a Web Speech API.');
      return;
    }
    cancelarVoz();

    const recognition = new SpeechRecognition();
    recognitionRef.current = recognition;

    recognition.lang = 'pt-BR';
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;

    recognition.onstart = () => setOuvindo(true);

    recognition.onresult = (event: SpeechRecognitionEvent) => {
      const resultado = event.results[0][0].transcript;
      onTranscricao?.(resultado);
    };

    recognition.onerror = (event: any) => {
      console.error('Erro:', event.error);
    };

    recognition.onend = () => setOuvindo(false);

    recognition.start();
  };

  const pararReconhecimento = () => {
    recognitionRef.current?.stop();
  };

  return (
    <IconButton
      color={ouvindo ? 'error' : 'primary'}
      onMouseDown={iniciarReconhecimento}
      onMouseUp={pararReconhecimento}
      onTouchStart={iniciarReconhecimento}
      onTouchEnd={pararReconhecimento}
      disabled={disabled}
    >
      <MicIcon />
    </IconButton>
  );
};

export default AudioParaTexto;
